import React, {Component} from "react";
import HomePlayInput from "../home-play-input.js";
import HomePlayFormErrorConsole from "../home-play-form-error-console.js";
import {validateEmail} from "../../../../services/utils/form.js";
import {addCircleMember, editCircleMember} from "../../../../modules/user.js";

class CircleMemberForm extends Component {
    constructor(props) {
        super(props);

        this.MODES = {
            ADD: 1,
            EDIT: 2
        };

        this.state = {
            canSend: false,
            formData: {},
            submitting: false,
            gotErrors: false,
            activated: false,
            errors: [],
            clear: false
        }
    }

    splitPlayerName(playerName) {
        let firstName;
        let lastName;
        if (playerName) {
            firstName = playerName.split(' ').slice(0, -1).join(' ');
            lastName = playerName.split(' ').slice(-1).join(' ');
            return [firstName, lastName];
        }
        else {
            return ["", ""];
        }

        
    }

    componentDidMount() {
        this.clear();
    }

    clear () {
        let formData = {
            first_name: "",
            last_name: "",
            email: "",
            relationship_to_user: "Spouse",
            phone_number: ""
        };

        this.setState({formData: formData, clear: true, activated: false, submitting: false});
    }

    setFormDataToCircleMember() {
        let {circle_member, cancel_circle_member_changed} = this.props;
        let formData = {
            first_name: circle_member.first_name,
            last_name: circle_member.last_name,
            email:  circle_member.email,
            relationship_to_user:  circle_member.relationship_to_user,
            phone_number: circle_member.phone_number
        };

        cancel_circle_member_changed();

        this.setState({
            formData: formData,
            errors: [],
            gotErrors: false
        })
    }


    updateFormData(inputName, newValue) {
        let {formData} = this.state;

        let newFormData = {};
        Object.assign(newFormData, formData); 

        newFormData[inputName] = newValue;

        this.setState({formData: newFormData});        
    }

    validateForm(formData) {
        let gotErrors = false;
        let errors = [];        
        let firstName = formData.first_name;
        let lastName = formData.last_name;
        let email = formData.email;

        if (!validateEmail(email)) {
            gotErrors = true;
            errors.push("Invalid Email address");
        }

        if (firstName.length < 2) {
            gotErrors = true;
            errors.push("First name must be at least 2 characters long");
        }

        if (lastName.length < 2) {
            gotErrors = true;
            errors.push("Last name must be at least 2 characters long");
        }

        this.setState({gotErrors: gotErrors, errors: errors});


        return !gotErrors;
    }

    circleMemberAdded(circleMember) {
        let {circle_member_added} = this.props;
        this.clear();
        circle_member_added(circleMember);
    }

    async submitForm(e) {
        let {token, player, mode, circle_member} = this.props;
        e.preventDefault();
        let {formData, submitting} = this.state;

        if (submitting) {
            return;
        }

        this.setState({submitting: true, gotErrors: false});

        let valid = this.validateForm(formData);

        if (!valid) {
            this.setState({submitting: false});
            return;
        }

        if (mode === this.MODES.ADD) {
            let activationResponse = await addCircleMember(token, player.id, formData.first_name, formData.last_name, formData.email, formData.relationship_to_user, formData.phone_number);
            if (activationResponse && activationResponse.data) {
                let activationData = activationResponse.data;
    
                if (activationData.success) {
                    this.setState({activated: true, submitting: false});
                    let newCircleMember = activationData.new_circle_member;
                    let that = this;
                    setTimeout(function() {
                        that.circleMemberAdded(newCircleMember);
                    }, 800);
                }
                else {
                    this.setState({gotErrors: true, errors: activationData.errors, submitting: false});
                }
            }
        }
        else {
            let editResponse = await editCircleMember(token, player.id, formData.first_name, formData.last_name, formData.email, formData.relationship_to_user, formData.phone_number, circle_member.id);
            if (editResponse && editResponse.data) {
                let editData = editResponse.data;
    
                if (editData.success) {
                    this.setState({activated: true, submitting: false});                                    
                    setTimeout(function() {
                        window.location.reload();
                    }, 800);
                }
                else {
                    this.setState({gotErrors: true, errors: editData.errors, submitting: false});
                }
            }
        }
        


      

    }
   
    hide() {
        let {hide_func} = this.props;
        this.clear();
        hide_func();
    }

    render() {
        let {show, hide_func, mode, circle_member, circle_member_changed} = this.props;
        let {submitting, gotErrors, errors, activated, clear} = this.state;

        if (clear) {
            this.setState({clear: false});
        }


        let title = "Add Circle Member";
        let buttonText = "Add";
        let successMessage = "Added Successfully";

        let firstNameValue = "";
        let lastNameValue = "";
        let emailValue = "";
        let phoneNumberValue = "";
        let relationshipValue = "";
        if (mode && mode === this.MODES.EDIT) {
            title = "Edit Circle Member";
            buttonText= "Save";
            successMessage = "Edit Successful";
            firstNameValue = circle_member.first_name;
            lastNameValue = circle_member.last_name;
            emailValue = circle_member.email;
            phoneNumberValue = circle_member.phone_number;
            relationshipValue = circle_member.relationship_to_user;
        }

        if (circle_member_changed) {
            this.setFormDataToCircleMember();
        }
        
        
        return (
            <div>
                {show && <div className='cirlce_member_form_modal' onClick={hide_func}></div>}
                {show && 
                <div className='circle_member_form_dialog_container'>
                    <div className='circle_member_form_dialog'>    
                    <div className='home_play_section_title'>{title}</div>
                        <HomePlayFormErrorConsole show={gotErrors} errors={errors} />
                        <form>
                            <HomePlayInput label="First Name" input_id="first_name" default_value={firstNameValue} clear={clear} wide={true} updateForm={this.updateFormData.bind(this)}  required={true}/>
                            <HomePlayInput label="Last Name" input_id="last_name" default_value={lastNameValue} clear={clear} wide={true}  updateForm={this.updateFormData.bind(this)}  required={true}/>
                            <HomePlayInput label="Email" input_id="email" special_type="email" default_value={emailValue} clear={clear} wide={true} updateForm={this.updateFormData.bind(this)}  required={true}/>
                            <HomePlayInput label="Phone Number" input_id="phone_number" default_value={phoneNumberValue} clear={clear} wide={true} updateForm={this.updateFormData.bind(this)}/>
                            <HomePlayInput label="Relationship to Patient" input_id="relationship_to_user" default_value={relationshipValue} wide={true} clear={clear} updateForm={this.updateFormData.bind(this)}  required={true}/>
                            {!submitting && <button className='home_play_form_submit center' onClick={this.submitForm.bind(this)}>{buttonText}</button>}
                            {submitting && <div>Working... <i className='fa fa-spin fa-spinner'></i></div>}
                            {activated && <div className='home_play_form_activated'>{successMessage} <i className='fa fa-check activation icon'></i></div>}
                        </form>
                        <div className="circle_member_dialog_close" onClick={this.hide.bind(this)}><i className='fa fa-times'></i></div>
                    </div>
                   
                </div>
                }
            </div>
        )
    }
}

export default CircleMemberForm;


// WEBPACK FOOTER //
// ./src/components/containers/home-play/circle-members/circle-member-form.js